import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=26e69bdf&scoped=true&"
import script from "./Delete.vue?vue&type=script&lang=js&"
export * from "./Delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e69bdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e69bdf')) {
      api.createRecord('26e69bdf', component.options)
    } else {
      api.reload('26e69bdf', component.options)
    }
    module.hot.accept("./Delete.vue?vue&type=template&id=26e69bdf&scoped=true&", function () {
      api.rerender('26e69bdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Customers/Delete.vue"
export default component.exports